import React, { useContext, useEffect, useState } from "react";
// import styled from "styled-components";

// import Goal from "../TopBar/Goal";
import { UIContext } from "../../contexts/UIContext";
import { Route, Switch, useParams } from "react-router";
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import { APIContext } from "../../contexts/APIContext";
import EFLTeamNames from "../TopBar/EFLTeamNames";
import EFLGame from "../Game/EFLGame";
import { GameEventsContext } from "../../contexts/GameEventContext";
import Timeline from "../Timeline/Timeline";
// import EFLGame from "../Game/EFLGame";

// import EFLTeamNames from "../TopBar/EFLTeamNames";

const OPTA_PERIODS = [
  { value: 16, name: "Pre-match" },
  { value: 1, name: "First half" },
  { value: 10, name: "Half time" },
  { value: 2, name: "Second half" },
  { value: 3, name: "Extra time first half" },
  { value: 4, name: "Extra time second half" },
  { value: 5, name: "Penalty shootout" },
  { value: 11, name: "End of second half (before extra time)" },
  { value: 12, name: "Extra time half time" },
  { value: 13, name: "End of extra time (before penalties)" },
  { value: 14, name: "Full time" },
];

const LINEUP_FIELDS = gql`
  fragment LINEUP_FIELDS on LineupObject {
    home {
      squad {
        _id
        shirt_number
        opta_shirt_number
        player {
          _id
          opta_ID
          first_name
          last_name
          first_name_upper
          last_name_upper
          opta_first_name
          opta_last_name
          date_of_birth
          foot
          height
          nationality {
            _id
            opta_code
            opta_name
          }
        }
      }
      order
      yellow_card
      dbl_yellow_card
      red_card
      sub_order
      subbed
      captain
    }
    away {
      squad {
        _id

        shirt_number
        opta_shirt_number
        player {
          _id
          opta_ID
          first_name
          last_name
          first_name_upper
          last_name_upper
          opta_first_name
          opta_last_name
          date_of_birth
          foot
          height
          nationality {
            _id
            opta_code
            opta_name
          }
        }
      }
      order
      yellow_card
      dbl_yellow_card
      red_card
      sub_order
      subbed
      captain
    }
  }
`;
const GAME_BY_ID = gql`
  ${LINEUP_FIELDS}
  query GameByID($id: String) {
    gameById(id: $id) {
      _id
      time
      description
      date
      home_team_kit
      away_team_kit
      opta_team_stats
      opta_player_stats
      stadium {
        opta_name
        name
      }
      competition {
        _id
        name
        badge
        competition_type
        colour
      }
      officials {
        official {
          first_name
          last_name
        }
        type
      }
      home_scorers
      away_scorers
      home_penalties
      away_penalties
      lineup {
        ...LINEUP_FIELDS
      }
      home_team {
        _id
        opta_ID
        name
        short_name
        code
        variables
      }
      away_team {
        _id
        opta_ID
        name
        short_name
        code
        variables
      }
      live_data
      home_formation
      away_formation
      season {
        _id
      }
      commentators {
        first_name
        last_name
      }
      config
      agg_home_score
      agg_away_score
      leg
      match_facts
    }
  }
`;

const GAME_SUBSCRIPTION = gql`
  ${LINEUP_FIELDS}
  subscription GameUpdated($id: String!) {
    gameUpdated(_id: $id) {
      _id
      home_team_kit
      away_team_kit
      lineup {
        ...LINEUP_FIELDS
      }
      live_data
      opta_team_stats
      opta_player_stats
      home_scorers
      away_scorers
      home_penalties
      away_penalties
      home_formation
      away_formation
      agg_home_score
      agg_away_score
      leg
      season {
        _id
      }
      commentators {
        first_name
        last_name
      }
      home_team {
        _id
        opta_ID
        name
        short_name
        code
        variables
      }
      away_team {
        _id
        opta_ID
        name
        short_name
        code
        variables
      }
      match_facts
    }
  }
`;
const OPTA_EVENT_SUBSCRIPTION = gql`
  subscription newOptaEvents($id: String!) {
    newOptaEvents(id: $id) {
      _id
      id
      game_ID {
        _id
      }
      typeId
      timeMin
      timeSec
      qualifier
      playerId
      contestantId
      eventId
      periodId
      timeStamp
      outcome
      playerName
      x
      y
    }
  }
`;
const OPTA_EVENT_BY_GAME = gql`
  query OptaEventByGame($id: String) {
    OptaEventByGame(id: $id) {
      _id
      id
      game_ID {
        _id
      }
      typeId
      timeMin
      timeSec
      qualifier
      playerId
      contestantId
      eventId
      periodId
      timeStamp
      outcome
      playerName
      x
      y
    }
  }
`;
// const Main = styled.div`
//   display: flex;
//   width: 100%;
// `;
// const Content = styled.div`
//   display: flex;
//   margin-left: 1em;
//   margin-right: 1em;
//   margin-top: 1em;
//   box-sizing: border-box;
//   flex: 1;
//   flex-direction: column;
// `;

export default function EFL({
  setSelectedPlayer,
  selectedPlayer,
  setSelectedSubPlayer,
  selectedSubPlayer,
}) {
  let { gameID } = useParams();
  const [game, setGame] = useState();
  const [group, setGroup] = useState();
  const [groups, setGroups] = useState();
  const [homeManager, setHomeManager] = useState();
  const [awayManager, setAwayManager] = useState();
  const [optaEvents, setOptaEvents] = useState();
  const { setEvents, setGame: setEventsGame } = useContext(GameEventsContext);
  const [getGame, { data, subscribeToMore }] = useLazyQuery(GAME_BY_ID, {
    fetchPolicy: "network-first",
  });
  const [
    getOptaEvent,
    { data: optaEventData, subscribeToMore: subscribeToMoreOPTA },
  ] = useLazyQuery(OPTA_EVENT_BY_GAME, {
    fetchPolicy: "network-first",
  });

  useEffect(() => {
    if (gameID) {
      getGame({ variables: { id: gameID } });
      getOptaEvent({ variables: { id: gameID } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameID]);

  useEffect(() => {
    let unsubscribe;
    if (subscribeToMore) {
      console.log("Subscribed");
      unsubscribe = subscribeToMore({
        document: GAME_SUBSCRIPTION,
        variables: { id: gameID },
        updateQuery: (prev, { subscriptionData }) => {
          if (!subscriptionData.data) return prev;

          const updatedGame = subscriptionData.data.gameUpdated;
          let newGame = {
            gameById: { ...prev.gameById, ...updatedGame },
          };

          return newGame;
        },
      });
    }
    return () => {
      console.log("Unsubscribed");
      unsubscribe && unsubscribe();
    };
  }, [subscribeToMore, gameID]);

  useEffect(() => {
    let unsubscribe;
    if (subscribeToMoreOPTA) {
      console.log("Subscribed");
      unsubscribe = subscribeToMoreOPTA({
        document: OPTA_EVENT_SUBSCRIPTION,
        variables: { id: gameID },
        updateQuery: (prev, { subscriptionData }) => {
          if (!subscriptionData.data) return prev;
          let new_obj = [...(prev?.OptaEventByGame || [])];
          for (
            let i = 0;
            i < subscriptionData.data.newOptaEvents?.length;
            i++
          ) {
            let ev = subscriptionData.data.newOptaEvents[i];
            new_obj = [
              ...(new_obj?.filter((e) => {
                return e.id !== ev.id;
              }) || []),
              ev,
            ];
          }

          return { OptaEventByGame: new_obj };
        },
      });
    }
    return () => {
      console.log("Unsubscribed");
      unsubscribe && unsubscribe();
    };
  }, [subscribeToMoreOPTA, gameID]);

  useEffect(() => {
    if (data) {
      setEventsGame(data.gameById);
      setGame(data.gameById);
    }
  }, [data]);

  useEffect(() => {
    if (optaEventData) {
      setEvents(
        [...(optaEventData.OptaEventByGame || [])].sort((a, b) => {
          let period_a = OPTA_PERIODS?.findIndex((p) => p.value === a.periodId);
          let period_b = OPTA_PERIODS?.findIndex((p) => p.value === b.periodId);

          if (period_a < period_b) {
            return -1;
          }
          if (period_a > period_b) {
            return 1;
          }
          if (a?.timeMin < b?.timeMin) {
            return -1;
          }
          if (a?.timeMin > b?.timeMin) {
            return 1;
          }

          if (a?.timeSec < b?.timeSec) {
            return -1;
          }
          if (a?.timeSec > b?.timeSec) {
            return 1;
          }
          return a?.timestamp - b?.timestamp;
        })
      );
      let sorted = [...optaEventData.OptaEventByGame];

      sorted = sorted
        .filter((item) => {
          // if (
          //   item.typeId === 1 || //PASS
          //   item.typeId === 2 || //Offside Pass
          //   item.typeId === 3 || //Take On
          //   item.typeId === 5 || //Out
          //   item.typeId === 7 || //Tackle
          //   item.typeId === 8 || //Interception
          //   item.typeId === 10 || //Save
          //   item.typeId === 11 || //Claim
          //   item.typeId === 12 || //Clearance
          //   item.typeId === 27 || //Start delay
          //   item.typeId === 28 || //End delay
          //   item.typeId === 34 || //TEAM SETUP
          //   item.typeId === 37 || //	Collection End
          //   item.typeId === 40 || //Formation change
          //   item.typeId === 41 || //Punch
          //   item.typeId === 42 || //Good skill
          //   item.typeId === 43 || //Deleted event
          //   item.typeId === 44 || //Aerial
          //   item.typeId === 45 || //Challenge
          //   item.typeId === 49 || //Ball recovery
          //   item.typeId === 50 || //Dispossessed
          //   item.typeId === 51 || //Error
          //   item.typeId === 52 || //Keeper pick-up
          //   item.typeId === 55 || //Offside provoked
          //   item.typeId === 59 || //Keeper Sweeper
          //   item.typeId === 61 || //Ball touch
          //   item.typeId === 74 //Blocked Pass
          // ) {
          //   return false;
          // }
          // if (
          //   item.typeId === 4 || //FOUL
          //   item.typeId === 6 || //Corners
          //   item.typeId === 13 || //Shot Miss
          //   item.typeId === 14 || //Shot Hit Post
          //   item.typeId === 15 || //Shot Saved
          //   item.typeId === 16 || //Goal
          //   item.typeId === 17 || //Card
          //   item.typeId === 18 || //Card
          //   item.typeId === 19 || //Card
          //   item.typeId === 30 || //End Period
          //   item.typeId === 32 || //KICK OFF
          //   item.typeId === 70 //Injury Time Announcement
          // ) {
          //   return true;
          // }
          // dont show corners in timeline
          // else if (item.typeId === 6) {
          //   if (item.outcome === 1) {
          //     return true;
          //   }
          // }
          //FOR EFL

          if (
            ((item.typeId === 13 || item.typeId === 14 || item.typeId === 15) &&
              item.qualifier.findIndex((q) => q.qualifierId === 9) > -1) ||
            item.typeId === 16 ||
            item.typeId === 17 ||
            item.typeId === 18 ||
            item.typeId === 19 ||
            item.typeId === 24 ||
            (item.typeId === 30 && item.periodId !== 14) ||
            item.typeId === 32 ||
            item.typeId === 70 ||
            item.typeId === 79 ||
            item.typeId === 922
          ) {
            return true;
          }

          return false;
        })
        .sort((a, b) => {
          let period_a = OPTA_PERIODS?.findIndex((p) => p.value === a.periodId);
          let period_b = OPTA_PERIODS?.findIndex((p) => p.value === b.periodId);

          if (period_a < period_b) {
            return -1;
          }
          if (period_a > period_b) {
            return 1;
          }
          if (a?.timeMin < b?.timeMin) {
            return -1;
          }
          if (a?.timeMin > b?.timeMin) {
            return 1;
          }

          if (a?.timeSec < b?.timeSec) {
            return -1;
          }
          if (a?.timeSec > b?.timeSec) {
            return 1;
          }
          return a?.timestamp - b?.timestamp;
        });
      setOptaEvents(sorted);
    }
  }, [optaEventData]);

  //   const { goal, setGoal } = useContext(UIContext);

  //   const { updateGame } = useContext(APIContext);

  if (!game) return <div>Loading</div>;
  return (
    game && (
      <div className="flex flex-col bg-gray-50 min-w-screen min-h-screen w-[calc(100vw-60px)] dark:bg-slate-950">
        <EFLTeamNames game={game} />
        <Timeline game={game} optaEvents={optaEvents} />
        <EFLGame game={game} optaEvents={optaEvents} />
        {/* //         <Content>
//           {!goal && (
//             <EFLTeamNames
//               setSelectedPlayer={setSelectedPlayer}
//               homeTeam={game.home_team}
//               awayTeam={game.away_team}
//               game={game}
//               group={group}
//             />
//           )}
//           {goal && (
//             <Goal
//               goal={goal}
//               setGoal={setGoal}
//               cancel={() => {
//                 updateGame({
//                   id: game._id,
//                   home_scorers: game.home_scorers.filter((g) => g.player),
//                   away_scorers: game.away_scorers.filter((g) => g.player),
//                 });
//                 setGoal();
//               }}
//             />
//           )}

//           <Switch>
//             <Route path="/:gameID">
               <EFLGame
                setHomeManager={setHomeManager}
                setAwayManager={setAwayManager}
                setGoal={setGoal}
                goal={goal}
                game={game}
                setSelectedPlayer={setSelectedPlayer}
                selectedPlayer={selectedPlayer}
                setSelectedSubPlayer={setSelectedSubPlayer}
                selectedSubPlayer={selectedSubPlayer}
                optaEvents={optaEvents}
              />
//             </Route>
//           </Switch>
//         </Content> */}
      </div>
    )
  );
}
